<template>
    <div style="display: inline-block">
        <b-dropdown id="dropdown-1" right :text="`${$i18n.locale.toUpperCase()}`">
            <b-dropdown-item-button><a href="#" @click.prevent="setLocale('de')"><b>DE</b></a></b-dropdown-item-button>
            <b-dropdown-item-button><a href="#" @click.prevent="setLocale('pl')"><b>PL</b></a></b-dropdown-item-button>
        </b-dropdown>
    </div>
</template>

<script>
import i18n from '../i18n';

export default {
    methods: {
        setLocale(locale) {
            this.$i18n.locale = locale;
            i18n.locale = locale;
            this.$router.push({
                params: { lang: locale }
            })
            this.$store.dispatch('changeLanguage', locale)
        },

        de: function () {
            this.$store.dispatch('changeLanguage', 'de')
        },

        pl: function () {
            this.$store.dispatch('changeLanguage', 'pl')
        }
    }
}
</script>

<style lang="scss">
#dropdown-1 {
  .btn {
    min-width: 50px;
    padding: 0.375rem 0.5rem;
    text-align: center;
  }

  .dropdown-menu {
    min-width: 50px;
    padding: 0;

    .dropdown-item {
      padding: 0.25rem 0.5rem;
      text-align: left;

      a {
        display: block;
        width: 100%;
        color: #333;
        text-decoration: none;
        padding: 0;
        margin: 0;

        &:hover {
          color: orange;
          text-decoration: none;
        }
      }
    }
  }
}

.dropdown-item a {
  color: #333;
  text-decoration: none;

  &:hover {
    color: orange;
    text-decoration: none;
  }
}
</style>